/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Workspace_Aside_Published_DescInputs */

const en_directory_submit_workspace_aside_published_desc = /** @type {(inputs: Directory_Submit_Workspace_Aside_Published_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The listing and platform assessments go live together.`)
};

const zh_directory_submit_workspace_aside_published_desc = /** @type {(inputs: Directory_Submit_Workspace_Aside_Published_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`条目和平台评估结果一起上线。`)
};

/**
* | output |
* | --- |
* | "The listing and platform assessments go live together." |
*
* @param {Directory_Submit_Workspace_Aside_Published_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_aside_published_desc = /** @type {((inputs?: Directory_Submit_Workspace_Aside_Published_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Aside_Published_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_aside_published_desc(inputs)
	return zh_directory_submit_workspace_aside_published_desc(inputs)
});
export { directory_submit_workspace_aside_published_desc as "directory.submit.workspace.aside.published_desc" }